// extracted by mini-css-extract-plugin
export default {"accountSwitcher":"styles_accountSwitcher__t875i","header":"styles_header__NcIyt","footer":"styles_footer__3M1ql","body":"styles_body__rIp4P","input":"styles_input__pcYQE"};